import type { AxiosError } from "axios";

import { ROUTES } from "@/router";
import { useUserStore } from "@/stores";
import type { ErrorResponse } from "../api.types";

export const errorResponse = async (error: AxiosError<ErrorResponse>) => {
  const status = error?.response?.status;

  if (status === 401) {
    useUserStore.getState().clearUser();
    window.location.href = ROUTES.login;
  }
  if (status && [404, 405].includes(status)) {
    window.location.href = ROUTES.notFound;
  }
  if (status && [500, 502, 503, 504].includes(status)) {
    window.location.href = ROUTES.serverError;
  }
  return Promise.reject(error.response?.data);
};
